import { Collection, Token } from './types';

/**
 * https://www.figma.com/file/ulUeUVSNgLMAYaeH0nJxCI/Den---Foundations?type=design&node-id=849-19102&mode=design&t=tX6QmtAs0Se6dnZ8-4
 */
export const space = new Collection({
  px: new Token('1px', 'space-px'), // Not in design system
  '0': new Token('0px', 'space-0'), // Not in design system
  '0.5': new Token('2px', 'space-0p5'), // Not in design system
  '1': new Token('4px', 'space-1'),
  '1.5': new Token('6px', 'space-1p5'), // Not in design system
  '2': new Token('8px', 'space-2'),
  '2.5': new Token('10px', 'space-2p5'), // Not in design system
  '3': new Token('12px', 'space-3'),
  '3.5': new Token('14px', 'space-3p5'), // Not in design system
  '4': new Token('16px', 'space-4'),
  '5': new Token('20px', 'space-5'),
  '6': new Token('24px', 'space-6'),
  '7': new Token('28px', 'space-7'),
  '8': new Token('32px', 'space-8'),
  '9': new Token('36px', 'space-9'),
  '10': new Token('40px', 'space-10'),
  '12': new Token('48px', 'space-12'),
  '14': new Token('56px', 'space-14'),
  '16': new Token('64px', 'space-16'),
  '20': new Token('80px', 'space-20'), // Not in design system
  '24': new Token('96px', 'space-24'),
  '28': new Token('112px', 'space-28'), // Not in design system
  '32': new Token('128px', 'space-32'),
  '36': new Token('144px', 'space-36'), // Not in design system
  '40': new Token('160px', 'space-40'), // Not in design system
  '44': new Token('176px', 'space-44'), // Not in design system
  '48': new Token('192px', 'space-48'), // Not in design system
  '52': new Token('208px', 'space-52'), // Not in design system
  '56': new Token('224px', 'space-56'), // Not in design system
  '60': new Token('240px', 'space-60'), // Not in design system
  '64': new Token('256px', 'space-64'), // Not in design system
  '72': new Token('288px', 'space-72'), // Not in design system
  '80': new Token('320px', 'space-80'), // Not in design system
  '96': new Token('384px', 'space-96'), // Not in design system
});
